import { render, staticRenderFns } from "./alert-modal.vue?vue&type=template&id=476a0589&scoped=true&"
import script from "./alert-modal.vue?vue&type=script&lang=js&"
export * from "./alert-modal.vue?vue&type=script&lang=js&"
import style0 from "./alert-modal.vue?vue&type=style&index=0&id=476a0589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a0589",
  null
  
)

export default component.exports